import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { getAllWorkers } from '../../../actions/workers';
import FilterWorkers from '../../common/AdvancedFilter/FilterWorkers';
import CreateWorker from '../createWorker';
import ListItemWorker from '../../common/lists/ListItem/ListItemWorker';
import PaginationBaseComponent from '../../common/PaginationBaseComponent';
import { stringifyWorkerFilterParams } from '../../../helpers/workers';
import { USERS_LIST_PAGE_SIZE } from '../../../constants/general';
import AdvancedFilterButton from '../../common/AdvancedFilter/AdvancedFilterButton';
import AdvancedFilter from '../../common/AdvancedFilter';
import { taxTypes } from '../../../constants/companies';
import { getAllSkills } from '../../../actions/skills';
import SearchCriteria from '../../common/AdvancedFilter/SearchCriteria';
import qs from 'qs';
import ListPageHeader from '../../common/lists/ListPageHeader';
import Close from '../../common/ui/Close';
import { getSelectedFilterValuesForUI, mapSkillsListToUI } from '../../../helpers/general';

export const pageTabs = {
  complete: {
    id: 'complete',
    ui: 'Onboarding Complete'
  },
  inprogress: {
    id: 'inprogress',
    ui: 'Onboarding In Progress'
  }
};

const emptyFilter = {
  full_name: '',
  state: '',
  onboarding_status: '',
  background_status: '',
  tax_type: taxTypes.W2,
  is_active: null,
  skill: [],
  rating: null,
  distance: '',
  zip: ''
};

class WorkersList extends PaginationBaseComponent {
  static propTypes = {
    initialData: PropTypes.array.isRequired,
    pagesQuantity: PropTypes.number.isRequired,
    skillsList: PropTypes.array.isRequired,
    getDataAction: PropTypes.func.isRequired,
    getAllSkills: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const { selectedTab, full_name, state, onboarding_status, background_status, tax_type, skill,
      is_active, rating, distance, zip } = query;
    const filteringValues = {
      full_name,
      state,
      onboarding_status,
      background_status,
      tax_type,
      skill,
      is_active: is_active || emptyFilter.is_active,
      rating,
      distance: distance || emptyFilter.distance,
      zip: zip || emptyFilter.zip
    };

    this.state = {
      activePage: this.getActivePage(),
      loading: false,
      filteringFieldsList: [],
      data: [],
      columns: [],
      selectedTab: selectedTab || pageTabs.complete.id,
      createModalIsOpen: false,
      filterModalIsOpen: false,
      filteringValues: filteringValues,
      appliedFilterParams: getSelectedFilterValuesForUI(filteringValues, emptyFilter),
      goToPageBtnIsShown: false
    };

    this.handleInputChangeDebounce = _.debounce(this._loadData, 500);
  }

  pageSize = USERS_LIST_PAGE_SIZE;

  _renderSkillLabels = () => {
    const { filteringValues: { skill } } = this.state;

    if (skill && skill.length) {
      const selectedSkills = mapSkillsListToUI(
        this.props.skillsList.filter(listItem =>
          skill.includes(String(listItem.id))
        )
      );

      this.handleChange('skill', selectedSkills);
    }
  };

  componentDidMount () {
    this._loadData(this.state.activePage);

    if (!this.props.skillsList.length) {
      this.props.getAllSkills()
        .then(this._renderSkillLabels);
    }
  }

  _loadData = (activePage = this.state.activePage) =>
    this.loadData(activePage, stringifyWorkerFilterParams(this.state));

  toggleCreateModal = () => {
    this.setState(prevState => ({
      createModalIsOpen: !prevState.createModalIsOpen
    }));
  };

  showFilter = () => this.setState({ filterModalIsOpen: true });

  closeFilterModal = () => this.setState({ filterModalIsOpen: false });

  handleChange = async (name, value) => this.setState({
    filteringValues: {
      ...this.state.filteringValues,
      [name]: value
    }
  });

  handleInputChange = event => this.handleChange(event.target.name, event.target.value).then(this.handleInputChangeDebounce);

  handleClearFilterParam = name => {
    this.handleChange(name, emptyFilter[name]).then(this.applyFilter);
  };

  handleClearMultipleFilterParam = (name, filterParam) => {
    let multipleValues = this.state.filteringValues[name];

    if (multipleValues.some(item => item.value === filterParam.value)) {
      multipleValues = multipleValues.filter(item => item.value !== filterParam.value);
    } else {
      multipleValues.push(filterParam);
    }

    return this.handleChange(name, multipleValues).then(this.applyFilter);
  };

  clearFilter = () => {
    this.setState({ filteringValues: emptyFilter }, () => this.applyFilter());
  };

  applyFilter = () => {
    const { filteringValues } = this.state;
    this.setState({
      appliedFilterParams: getSelectedFilterValuesForUI(filteringValues, emptyFilter)
    });
    this._loadData();
    this.closeFilterModal();
  };

  switchTab = event => this.setState({ selectedTab: event.target.id }, this._loadData);

  render () {
    const { history, pagesQuantity, initialData, skillsList } = this.props;
    const { createModalIsOpen, loading, selectedTab, filterModalIsOpen, filteringValues, appliedFilterParams } = this.state;

    return (
      <div>
        <ListPageHeader onClick={this.toggleCreateModal} icon={faUsers} title='Workers' />

        <div className='filter-params d-flex flex-wrap mb-3'>
          <div className='position-relative align-self-center col-12 mb-3 mb-md-0 col-md-9 p-0'>
            {!!filteringValues.full_name && (
              <Close onClick={() => this.handleClearFilterParam('full_name')} className='button-clear' />
            )}

            <input
              className='input'
              name='full_name'
              value={filteringValues.full_name || ''}
              onChange={this.handleInputChange}
              placeholder='Type full name, email or phone number'
            />
          </div>

          <AdvancedFilterButton
            onClick={this.showFilter}
            isFilterApplied={appliedFilterParams && appliedFilterParams.length > 0}
          />
        </div>

        <AdvancedFilter
          applyFilter={this.applyFilter}
          showFilter={filterModalIsOpen}
          closeFilter={this.closeFilterModal}
          clearFilter={this.clearFilter}
          Layout={FilterWorkers}
          handleChange={this.handleChange}
          skillsList={skillsList}
          {...filteringValues}
        />

        <SearchCriteria
          appliedFilterParams={appliedFilterParams}
          handleClearMultipleFilterParam={this.handleClearMultipleFilterParam}
          handleClearFilterParam={this.handleClearFilterParam}
        />

        <CreateWorker
          isOpen={createModalIsOpen}
          toggleModal={this.toggleCreateModal}
          history={history}
        />

        <div className='tabs-wrapper'>
          <button
            id={pageTabs.complete.id}
            className={selectedTab === pageTabs.complete.id ? 'tab active' : 'tab'}
            onClick={this.switchTab}
          >{pageTabs.complete.ui}</button>
          <button
            id={pageTabs.inprogress.id}
            className={selectedTab === pageTabs.inprogress.id ? 'tab active' : 'tab'}
            onClick={this.switchTab}
          >{pageTabs.inprogress.ui}</button>
        </div>

        <div className={`list ${loading && 'is-loading'}`}>
          {initialData.map(item => (
            <ListItemWorker
              key={item.id}
              worker={item}
              isOnboarded={selectedTab === pageTabs.complete.id}
            />
          ))}
        </div>

        {pagesQuantity > 1 && this.renderPagination()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    initialData: state.workers.workersList,
    skillsList: state.skillsList,
    pagesQuantity: state.workers.pagesQuantity
  };
};

const mapDispatchToProps = {
  getDataAction: getAllWorkers,
  getAllSkills
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkersList);



// WEBPACK FOOTER //
// ./src/components/app/workersList/index.js